export function ImgTrash({ size = 16 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 2.5V3H4V5H16V3H12V2.5C12 1.67 11.33 1 10.5 1H9.5C8.67 1 8 1.67 8 2.5Z" fill="currentColor"/>
      <path d="M5 6V16.5C5 17.33 5.67 18 6.5 18H13.5C14.33 18 15 17.33 15 16.5V6H5ZM8 8V15H7V8H8ZM10.5 8V15H9.5V8H10.5ZM13 8V15H12V8H13Z" fill="currentColor"/>
    </svg>
  );
}
